// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DtXNg","left":"styles_left__1ofGl","right":"styles_right__1_qru","alert":"styles_alert__3EJf8"};